import { VendasListarOrigensLeadService } from "../../../Services/Vendas/OrigemLead/OrigemLeadService";
import { Controller } from "../../Controller";

export async function VendasListarOrigensLeadController() {
    return Controller(VendasListarOrigensLeadService());
}
